import SectionHeading from "@/pages/home/components/SectionHeading";
import { detailNotes, detailImage } from "@/mocks/insights";

const attentionStyles: Record<string, string> = {
  高: "bg-accent-100 text-accent-800",
  中: "bg-primary-100 text-primary-800",
  低: "bg-secondary-100 text-secondary-900",
};

export default function Insights() {
  return (
    <section id="insights" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="04"
          eyebrow="细节分析"
          title="决定走向的，往往是这些不起眼的小地方"
          desc="逐条拆解事件中的关键细节，标注重要程度与出处，看完你就知道争论卡在哪一步。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7 xl:col-span-8">
            <ul className="divide-y divide-background-200/80 border-t border-b border-background-200/80">
              {detailNotes.map((note) => (
                <li
                  key={note.no}
                  className="group flex items-start gap-4 md:gap-6 py-5 transition-colors hover:bg-background-50/70 cursor-pointer"
                >
                  <span className="font-heading text-lg md:text-2xl font-bold text-background-400 group-hover:text-primary-400 transition-colors w-8 md:w-10 shrink-0">
                    {note.no}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-3">
                      <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                        {note.title}
                      </h3>
                      <span
                        className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] ${attentionStyles[note.attention]}`}
                      >
                        关注度 {note.attention}
                      </span>
                    </div>
                    <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {note.summary}
                    </p>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors mt-1 shrink-0" />
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-5 xl:col-span-4">
            <div className="relative w-full h-72 md:h-[420px] rounded-lg overflow-hidden bg-background-200">
              <img
                src={detailImage}
                alt="黑料看点 细节分析 手绘脉络笔记"
                title="黑料看点 细节分析"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="text-xs tracking-[0.2em] text-primary-200">拆解手记</div>
                <p className="mt-2 text-sm text-background-100 leading-relaxed">
                  我们把每一条信息拆成「出处 / 时间 / 语境」三栏，冲突的地方不抹平，而是并排放在一起——
                  这样你看到的不是结论，而是通往结论的路径。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}